<style scoped lang="stylus">
.Config
	width 320px
	
	background #555
	color #dddddd
	padding-bottom 8px

input[type="checkbox"]
	margin 8px 8px 0 0

.block
	margin 24px 0 24px 0	

.title
	font-size 2rem
	font-weight 600
	text-align center
	padding 8px 0 0
	//font-style italic

.sub-title
	font-weight 300
	font-size 0.9rem
	text-align center
	line-height 2rem
	padding 0px 0 0
	font-style italic

.main
	width 220px
	margin 0 auto

h1
	display inline-block
	font-weight 500
	font-size 1.1rem
	
	margin 8px 0 20px 0
	&.colors
		margin 0px 0 12px 0
	
h2
	font-size 1rem
	font-weight normal
	display inline-block
	line-height 0.6rem
	margin 0
	
.row
	margin 0 0 4px 12px

.row.slider
	margin-bottom 20px

.slider > .vue-slider-component
	margin-top 36px

.ColorPicker
	display inline-block
	>>> .selected-square
		width 24px
		height 24px

.toggle
	border-bottom solid 1px #888
	cursor pointer
	width 50px

span.info
	font-size 0.8rem
	font-style italic
	color #aaaaaa
	display inline-block
	padding-left 12px

.cell
	display inline-block

	&.left1
		width 140px
		&>label	
			vertical-align 32%

	&.left2
		width 108px

	input 
		border none
		border-bottom solid 1px #888
		width 50px
		padding 2px 4px
		font-size 1rem
		background-color rgba(0,0,0,0.9)
		color #eeeeee
		text-align right

.start
	width 100%
	font-size 1.05rem

.table
	display grid
	grid-template-rows 1fr 1fr
	grid-template-columns 1fr 1fr
</style>


<template lang="pug">
	div.Config
		div.title breath.fi
		div.sub-title a guided breathing tool

		div.main
			.block
				h1.colors Colors
				div.table
					.cell.left
						label Breath 
					.cell.right
						label Background
				
					.cell.left
						color-picker(v-model="colorBreath")
					.cell.right
						color-picker(v-model="colorBackground")

			.block
				h1 Breath&nbsp;
					h2 (seconds)
				div.row.slider
					div.top
						.cell.toggle(v-on:click="visInhale = !visInhale") Inhale 
						span.info Start: {{inhale[0]}}s &nbsp; End: {{inhale[1]}}s
					vue-slider(ref="sliderInhale" v-model="inhale" v-bind="sliderOptionsHale" v-if="visInhale")
				div.row.slider
					div.top
						.cell.toggle(v-on:click="visHold1 = !visHold1")  Hold 1
						span.info Start: {{hold1[0]}}s &nbsp; End: {{hold1[1]}}s
					vue-slider(ref="sliderHold1" v-model="hold1" v-bind="sliderOptionsHold" v-if="visHold1")
				div.row.slider
					div.top
						.cell.toggle(v-on:click="visExhale = !visExhale")  Exhale
						span.info Start: {{exhale[0]}}s &nbsp; End: {{exhale[1]}}s
					vue-slider(ref="sliderExhale" v-model="exhale" v-bind="sliderOptionsHale" v-if="visExhale")
				div.row.slider
					div.top
						.cell.toggle(v-on:click="visHold2 = !visHold2")  Hold 2
						span.info Start: {{hold2[0]}}s &nbsp; End: {{hold2[1]}}s
					vue-slider(ref="sliderHold2" v-model="hold2" v-bind="sliderOptionsHold" v-if="visHold2")

			.block
				h1.toggle(style="width:auto" v-on:click="visSession = !visSession") Session&nbsp;
				span.info {{length}} minutes
				div.row.slider(v-if="visSession")
					vue-slider(ref="sliderLength" v-model="length" v-bind="sliderOptionsLength")
				div.row()
					input(type="checkbox" v-model="duration.stopWhenDone" id="cbstopWhenDone")
					label(for="cbstopWhenDone") Stop when done
			

			.block
				div.start-row
					button.start(v-on:click="start") Start
				

</template>




<script>
import { Sketch } from 'vue-color'
import ColorPicker from './ColorPicker.vue'
import { parse } from 'babylon';
import vueSlider from 'vue-slider-component';

export default {
	props: ['ColorBackground', 'ColorBreath', 'Duration'],
	name: "Config",
	components: {
		'sketch-picker': Sketch,
		ColorPicker,
		vueSlider,
	},
	data: function () {
		return {
			inhale:[5, 10],
			exhale:[5, 10],
			hold1:[1, 2],
			hold2:[1, 2],
			length: 10,

			sliderOptionsHale:{	// inhale/exhale
				min:0.2,
				max:20,
				interval:0.1,
				tooltip: "always",
				formatter: "{value} s",
				tooltipDir: "top"
			},
			sliderOptionsHold:{
				min:0.2,
				max:10,
				interval:0.1,
				tooltip: "always",
				formatter: "{value} s",
				tooltipDir: "top"
			},
			sliderOptionsLength:{
				min: 1,
				max: 60,
				interval: 1,
				formatter: "{value} m",
			},

			visInhale: false,
			visHold1:  false,
			visExhale: false,
			visHold2:  false,
			visSession:false,


			colorBreath: this.ColorBreath,
			colorBackground: this.ColorBackground,
			duration: {
				startInhale: 0,
				startHold1: 0,
				startExhale: 0,
				startHold2: 0,
				endInhale: 0,
				endHold1: 0,
				endExhale: 0,
				endHold2: 0,
				length: 0,
				stopWhenDone: true
			},
		}	
	},
	mounted: function(){
		this.duration.startInhale = this.Duration.startInhale / 1000
		this.duration.startHold1 = this.Duration.startHold1 / 1000
		this.duration.startExhale = this.Duration.startExhale / 1000
		this.duration.startHold2 = this.Duration.startHold2 / 1000
		this.duration.endInhale = this.Duration.endInhale / 1000
		this.duration.endHold1 = this.Duration.endHold1 / 1000
		this.duration.endExhale = this.Duration.endExhale / 1000
		this.duration.endHold2 = this.Duration.endHold2 / 1000
		this.duration.length = this.Duration.length / 1000 / 60
		this.stopWhenDone = this.Duration.stopWhenDone
	},
	watch:{
		colorBreath: function(n, o){
			this.$emit('changeColorBreath', n)
		},
		colorBackground: function(n, o){
			this.$emit('changeColorBackground', n)
		}
	},
	methods:{
		start(){
			this.Duration.startInhale = parseFloat(this.inhale[0]) * 1000
			this.Duration.startHold1 = parseFloat(this.hold1[0]) * 1000
			this.Duration.startExhale = parseFloat(this.exhale[0]) * 1000
			this.Duration.startHold2 = parseFloat(this.hold2[0]) * 1000

			this.Duration.endInhale = parseFloat(this.inhale[1]) * 1000
			this.Duration.endHold1 = parseFloat(this.hold1[1]) * 1000
			this.Duration.endExhale = parseFloat(this.exhale[1]) * 1000
			this.Duration.endHold2 = parseFloat(this.hold2[1]) * 1000

			this.Duration.length = parseFloat(this.length) * 1000 * 60
			this.Duration.stopWhenDone = this.duration.stopWhenDone

			this.$emit('start', true)
		},
		numericOnly(e){
			console.log(e.key, e.which)
			e = (e) ? e : window.event
			var c = (e.which) ? e.which : e.keyCode;
			if((c >= 48 && c <=58) || c == 46 )
				return true
			else
				e.preventDefault()
		},

	}
};


</script>


